import { useEffect, useRef } from 'react';

export const useIsFirstRender = (): boolean => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  return isFirstRender.current;
};
